/* ==========================================================================
   sections/project-quote-form.liquid - dedicated behaviour script.
   Nothing here reads section.settings, so it lives as a static asset
   instead of an inline <script> block.

   Same pattern as sections/trade-signup.liquid: native Shopify contact
   form -> stash the lead on submit -> on the success render, fire it to
   Google Ads (dataLayer), Klaviyo, and a Google Sheets Apps Script web app.
   ========================================================================== */

(function () {
  // ---- Form behaviour: honeypot + submit stash. --------------------------
  var form = document.getElementById('pqf-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var hp = document.getElementById('pqf-hp');
      if (hp && hp.value !== '') {
        e.preventDefault();
        return;
      }
      stashLead();
    });

    initInlineValidation(form);
  }

  // ---- Inline validation messages. ----------------------------------------
  // A page-wide ".page-wrap { overflow: hidden }" (used site-wide, e.g. for
  // the mobile slideout nav) clips the browser's native validation bubble
  // everywhere on the site, so an invalid field is silently focused with no
  // visible message. Native constraint validation still runs correctly and
  // blocks submission (type="email"/required stay untouched) - this only
  // replaces the (already-invisible) native popup with an inline message,
  // via the standard invalid-event pattern.
  function initInlineValidation(form) {
    var fields = form.querySelectorAll('input, select, textarea');

    Array.prototype.forEach.call(fields, function (field) {
      if (field.id === 'pqf-hp') return; // honeypot - no constraints, skip

      var touched = false;

      field.addEventListener('invalid', function (e) {
        e.preventDefault(); // suppresses the (already-invisible) native bubble -
                             // and its auto-focus/scroll, restored below
        touched = true;
        showFieldError(field);

        // "invalid" fires on every invalid field in the same pass; only act
        // for whichever one is currently first in tree order, so a failed
        // submit lands the visitor on the first error, not the last.
        if (field === form.querySelector(':invalid')) {
          field.focus({ preventScroll: true });
          field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      field.addEventListener('blur', function () {
        touched = true;
        validateField(field);
      });

      field.addEventListener('input', function () {
        if (touched) validateField(field);
      });

      field.addEventListener('change', function () {
        validateField(field);
      });
    });
  }

  function validateField(field) {
    if (field.validity.valid) {
      clearFieldError(field);
    } else if (field.value.trim() !== '') {
      // Don't nag about an untouched empty required field until submit is
      // attempted (that's what the "invalid" listener above covers).
      showFieldError(field);
    }
  }

  // Generic, consistent copy instead of the browser's own validationMessage,
  // which varies by browser/locale and gets overly specific (e.g. Chrome's
  // "'test' is missing an '@'" - wrong wording the moment the value changes
  // shape, and different wording entirely in Firefox/Safari).
  function getErrorMessage(field) {
    var v = field.validity;
    if (v.valueMissing) return 'This field is required.';
    if (v.typeMismatch || v.patternMismatch) {
      return field.type === 'email'
        ? 'Please enter a valid email address.'
        : 'Please enter a valid value.';
    }
    if (v.tooShort) return 'Please enter at least ' + field.minLength + ' characters.';
    if (v.tooLong) return 'Please enter no more than ' + field.maxLength + ' characters.';
    return 'Please enter a valid value.';
  }

  function showFieldError(field) {
    var container = field.closest('.pqf__field');
    if (!container) return;

    var msg = container.querySelector('.pqf__field-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'pqf__field-error';
      msg.id = field.id + '-error';
      container.appendChild(msg);
    }
    msg.textContent = getErrorMessage(field);

    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', msg.id);
    container.classList.add('pqf__field--invalid');
  }

  function clearFieldError(field) {
    var container = field.closest('.pqf__field');
    if (!container) return;

    var msg = container.querySelector('.pqf__field-error');
    if (msg) msg.textContent = '';

    field.removeAttribute('aria-invalid');
    container.classList.remove('pqf__field--invalid');
  }

  function stashLead() {
    try {
      var lead = { submission_id: newId(), page_url: window.location.href };
      Array.prototype.forEach.call(
        form.querySelectorAll('[name^="contact["]'),
        function (el) {
          var key = el.name.slice(8, -1); // contact[Foo] -> Foo
          if (key === 'Fax') return;      // honeypot
          lead[key] = (el.value || '').trim();
        }
      );
      lead.email = (lead.email || '').toLowerCase();
      sessionStorage.setItem('wr_quote_lead', JSON.stringify(lead));
    } catch (err) {
      console.warn('[WR quote] could not stash lead', err);
    }
  }

  function newId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
})();

(function () {
  "use strict";

  // ---- Config -------------------------------------------------------------
  var KLAVIYO_COMPANY_ID = "WAipVe"; // Klaviyo public API key (site-wide, same as trade-signup)
  var KLAVIYO_LIST_ID    = "";       // TODO: which list should these leads subscribe to?
  var KLAVIYO_REVISION   = "2025-10-15";
  var SHEETS_URL         = "https://script.google.com/macros/s/AKfycbyxlHYK2lqUW9SqrdBjbbDzsLLAdjiAA3-sqhFeCyVdBzGhl9pPJTpoETMRCy6I11CN/exec";
  var LEAD_TYPE          = "project_quote";
  var LEAD_SOURCE        = "Get a Project Quote Page";
  var LEAD_VALUE         = 0;
  var LEAD_CURRENCY      = "USD";

  var DEBUG = /[?&]wr_debug=1/.test(window.location.search);
  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[WR quote]'].concat([].slice.call(arguments)));
  }

  var successEl = document.getElementById('pqf-form-success');

  if (!successEl) {
    try {
      if (sessionStorage.getItem('wr_quote_lead')) {
        console.warn('[WR quote] A stashed lead exists but this is not the success render.');
      }
    } catch (err) { /* storage blocked */ }
    return;
  }

  // The contact form posts back via a full page redirect with no #anchor, so
  // the browser lands at the very top of the page and the success message
  // (rendered inside the form, well below the hero) goes unseen - it just
  // looks like the page reset. Scroll it into view, clearing any fixed header.
  scrollToSuccess(successEl);

  function scrollToSuccess(el) {
    var header = document.querySelector('.theme-header');
    var headerHeight = header ? header.offsetHeight : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  var raw = null;
  try {
    raw = sessionStorage.getItem('wr_quote_lead');
    sessionStorage.removeItem('wr_quote_lead');
  } catch (err) { /* storage blocked */ }

  if (!raw) { log('success render, no stash - nothing to track (expected on refresh)'); return; }

  var lead;
  try { lead = JSON.parse(raw); } catch (err) { return; }
  if (!lead || !lead.email) { log('stash unusable', lead); return; }

  log('firing for', lead.submission_id, lead.email);

  try { history.replaceState(null, '', window.location.pathname); } catch (err) { /* non-fatal */ }

  pushGenerateLead(lead);
  sendToKlaviyo(lead);
  sendToSheets(lead);

  function pushGenerateLead(lead) {
    window.dataLayer = window.dataLayer || [];
    var user_data = { email_address: lead.email };
    if (lead.first_name) user_data.first_name = lead.first_name;

    window.dataLayer.push({
      event: 'generate_lead',
      lead_type: LEAD_TYPE,
      form_id: 'pqf-form',
      value: LEAD_VALUE,
      currency: LEAD_CURRENCY,
      transaction_id: lead.submission_id,
      user_data: user_data
    });
  }

  function sendToKlaviyo(lead) {
    var props = {
      'Lead Source': LEAD_SOURCE,
      'Quote Status': 'Requested',
      'Quote Request Date': new Date().toISOString(),
      'Quote Form ID': 'pqf-form',
      'Submission ID': lead.submission_id
    };
    [
      ['Project Name',     'Project Name'],
      ['Project Type',     'Project Type'],
      ['Quoting',          'What Are You Quoting'],
      ['Product Link',     'Product Link'],
      ['Quantity',         'Quantity'],
      ['Project Location', 'Project Location'],
      ['Target Date',      'Target Date'],
      ['Project Links',    'Project Links'],
      ['body',             'Notes']
    ].forEach(function (pair) {
      if (lead[pair[0]]) props[pair[1]] = lead[pair[0]];
    });

    var attrs = { email: lead.email, properties: props };
    if (lead.first_name)      attrs.first_name   = lead.first_name;
    if (lead['Company Name']) attrs.organization = lead['Company Name'];

    var headers = { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION };

    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ data: { type: 'profile', attributes: attrs } }),
      keepalive: true
    })
    .catch(function (err) { console.error('[WR Klaviyo profile]', err); })
    .then(function () {
      if (!KLAVIYO_LIST_ID) { log('KLAVIYO_LIST_ID not set - skipping subscribe'); return; }

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: LEAD_SOURCE,
              profile: { data: { type: 'profile', attributes: {
                email: lead.email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        }),
        keepalive: true
      });
    })
    .catch(function (err) { console.error('[WR Klaviyo subscribe]', err); });
  }

  function sendToSheets(lead) {
    if (!SHEETS_URL) return;

    var payload = {
      'Submission ID':        lead.submission_id,
      'Timestamp':             new Date().toISOString(),
      'Lead Source':           LEAD_SOURCE,
      'Name':                  lead.first_name || '',
      'Studio / Company':      lead['Company Name'] || '',
      'Email':                 lead.email || '',
      'Project Name / Client': lead['Project Name'] || '',
      'Project Type':          lead['Project Type'] || '',
      'What Are You Quoting':  lead['Quoting'] || '',
      'Product Link / SKU':    lead['Product Link'] || '',
      'Quantity / Dimensions': lead['Quantity'] || '',
      'Project Location':      lead['Project Location'] || '',
      'Target Date':           lead['Target Date'] || '',
      'Project Links':         lead['Project Links'] || '',
      'Notes':                 lead.body || '',
      'Page URL':              lead.page_url || ''
    };

    var body = JSON.stringify(payload);
    if (navigator.sendBeacon && navigator.sendBeacon(SHEETS_URL, body)) return;
    fetch(SHEETS_URL, { method: 'POST', mode: 'no-cors', body: body, keepalive: true })
      .catch(function (err) { console.error('[WR quote Sheets]', err); });
  }
})();
